import { render, staticRenderFns } from "./VideoTOC.vue?vue&type=template&id=330283ba"
import script from "./VideoTOC.vue?vue&type=script&lang=js"
export * from "./VideoTOC.vue?vue&type=script&lang=js"
import style0 from "./VideoTOC.vue?vue&type=style&index=0&id=330283ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports